import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';

const Duties = (props) => {
  const { cartOrOrder } = props;

  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { duties } = cartOrOrder;

  if (!duties) {
    return null;
  }

  const dutyPaid = duties.filter((duty) => duty.isUnpaidDutyEstimate === false);
  return (
    <>
      {dutyPaid.map((duty) => (
        <div className="c7-order-summary__item" key={duty.id}>
          <div className="c7-order-summary__title">{duty.title}</div>
          <div className="c7-order-summary__value">
            {currencyFormat(duty.price, currency)}
          </div>
        </div>
      ))}
    </>
  );
};

export default Duties;
